module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.freight && _vm.freight.id) ? _c('div', {
    staticClass: "z-rl-freight-container"
  }, [_c('div', {
    staticClass: "z-rl-freight",
    class: {
      'active': _vm.isOpen,
      'has-error': (_vm.$props.error && _vm.$props.error.length)
    }
  }, [(_vm.$props.showRemove) ? _c('div', {
    staticClass: "z-rl-freight-close",
    on: {
      "click": _vm.remove
    }
  }, [_c('md-icon', [_vm._v("clear")])], 1) : _vm._e(), (_vm.sortedRouteList && _vm.sortedRouteList.length) ? _c('div', {
    staticClass: "z-rl-freight-divider"
  }) : _vm._e(), _c('div', {
    staticClass: "z-rl-freight__left",
    class: {
      'full': (!_vm.sortedRouteList || !_vm.sortedRouteList.length)
    }
  }, [_c('div', {
    staticClass: "z-rl-freight__top"
  }, [_c('div', {
    staticClass: "z-rl-freight__left__left"
  }, [_c('div', {
    staticClass: "z-rl-freight__left__number"
  }, [_c('span', [_vm._v(_vm._s(_vm.freight.traking_number))]), (_vm.hasDoom) ? _c('span', [_vm._v("*")]) : _vm._e()]), _c('div', {
    staticClass: "z-rl-freight__left__dimensions"
  }, [_c('span', {
    staticClass: "z-rl-freight__left__dimension weight"
  }, [_vm._v(_vm._s((_vm.realWeight + "кг")))]), _c('span', {
    staticClass: "z-rl-freight__left__dimension volume"
  }, [_c('span', [_vm._v(_vm._s(_vm.realVolume))]), _vm._m(0)]), _c('span', {
    staticClass: "z-rl-freight__left__dimension seats"
  }, [_vm._v(_vm._s(("" + _vm.realSeats)))])]), (_vm.freight.status) ? _c('div', {
    staticClass: "z-rl-freight__left__status",
    style: ('color: ' + _vm.freight.status.color + ';')
  }, [_vm._v(_vm._s(_vm.freight.status.name))]) : _vm._e(), (_vm.$props.showForwardTypeLabel && _vm.forwardMethodLocal) ? _c('div', {
    staticClass: "z-rl-freight__left__forward-method"
  }, [_vm._v(_vm._s(_vm.forwardMethodLocal))]) : _vm._e()]), _c('div', {
    staticClass: "z-rl-freight__left__center"
  }, [_c('div', {
    staticClass: "z-rl-freight__left__from"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Откуда: ")]), (!_vm.freight.deal.from_address_id && _vm.freight.deal && _vm.freight.deal.from_stock) ? _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.freight.deal.from_stock.name))]) : _vm._e(), (_vm.freight.deal.from_address_id && _vm.freight.deal && _vm.freight.deal.from_address) ? _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.freight.deal.from_address.address))]) : _vm._e()]), _c('div', {
    staticClass: "z-rl-freight__left__to"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Куда:")]), (!_vm.freight.deal.to_address_id && _vm.freight.deal && _vm.freight.deal.to_stock) ? _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.freight.deal.to_stock.name))]) : _vm._e(), (_vm.freight.deal.to_address_id && _vm.freight.deal && _vm.freight.deal.to_address) ? _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.freight.deal.to_address.address))]) : _vm._e()])])]), (_vm.isOpen && _vm.freight.deal_id) ? _c('div', {
    staticClass: "z-rl-freight__bottom"
  }, [_c('z-deal-view', {
    attrs: {
      "deal-id": parseInt(_vm.freight.deal_id)
    }
  })], 1) : _vm._e()]), (_vm.sortedRouteList && _vm.sortedRouteList.length) ? _c('div', {
    staticClass: "z-rl-freight__center"
  }, [_c('div', {
    staticClass: "z-rl-freight__center__roulte-lists"
  }, _vm._l((_vm.sortedRouteList), function(routeList, i) {
    return ((i <= 2 || _vm.isOpen)) ? _c('router-link', {
      key: ('rl-' + i + '-' + routeList.id),
      staticClass: "z-rl-freight__center__roulte-list",
      style: ('color: ' + _vm.getStatusColor(routeList) + ';'),
      attrs: {
        "to": {
          name: (_vm.$props.storekeeperView ? 'StorekeepersItinerary' : 'Itinerary'),
          props: {
            id: routeList.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "z-rl-freight__center__roulte-field z-rl-freight__center__roulte-list__id"
    }, [(routeList.id) ? _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(routeList.id))]) : _vm._e()]), _c('div', {
      staticClass: "z-rl-freight__center__roulte-field z-rl-freight__center__roulte-list__type"
    }, [(routeList.type_name) ? _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(routeList.type_name))]) : _vm._e()]), _c('div', {
      staticClass: "z-rl-freight__center__roulte-field z-rl-freight__center__roulte-list__name"
    }, [(routeList.status && routeList.status.message) ? _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(routeList.status.message))]) : _vm._e()])]) : _vm._e()
  }))]) : _vm._e(), _c('div', {
    staticClass: "z-rl-freight__right",
    class: {
      'active': _vm.isOpen
    }
  }, [_c('div', {
    staticClass: "z-rl-freight__toggle-btn",
    class: {
      'active': _vm.isOpen
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-down"
  })])])]), (_vm.$props.error && _vm.$props.error.length) ? _c('div', {
    staticClass: "z-rl-freight-errors"
  }, _vm._l((_vm.$props.error), function(error, i) {
    return _c('div', {
      key: ('error-' + _vm.freight.id + '-' + i),
      staticClass: "z-rl-freight-error"
    }, [_c('md-icon', [_vm._v("error_outline")]), _c('span', {
      staticClass: "z-rl-freight-error__text"
    }, [_vm._v(_vm._s(error))])], 1)
  })) : _vm._e(), (_vm.$props.warning && _vm.$props.warning.length) ? _c('div', {
    staticClass: "z-rl-freight-warnings"
  }, _vm._l((_vm.$props.warning), function(warning, i) {
    return _c('div', {
      key: ('error-' + _vm.freight.id + '-' + i),
      staticClass: "z-rl-freight-warning"
    }, [_c('md-icon', [_vm._v("error_outline")]), _c('span', {
      staticClass: "z-rl-freight-warning__text"
    }, [_vm._v(_vm._s(warning))])], 1)
  })) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("м"), _c('sup', [_vm._v("3")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-231ba6b1","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZRLFreight.vue
// module id = 1070
// module chunks = 0